import IconButton from "../../../../components/IconButton";
import { IconX } from "../../../../icons";
import "./modalApprovalHours.scss";

interface ModalMessageApprovalHoursProps {
  text: string;
  status: boolean;
  onClickCancel: (event?: any) => void;
  onClickConfirm: (event?: any) => void;
  onClickPreenchiConfirm: (event?: any) => void;
}

export function ModalMessageApprovalHours({ status, text, onClickCancel, onClickConfirm, onClickPreenchiConfirm }: ModalMessageApprovalHoursProps) {
  return (
    <>
      {status && (
        <div className="container">
          <div className="modalApprovalHours-Overlay bg-overlayModal"></div>
          <div className="modalApprovalHours-container">
            <IconButton className="modalApprovalHours-container__iconX" icon={IconX} onClick={() => onClickCancel(!status)} />
            <h1 className="modalApprovalHours-container__title">{text}</h1>
            <div className="modalApprovalHours-buttons">
              <button
                className="btn bg-primary"
                type="button"
                onClick={() => {
                  onClickConfirm();
                  onClickCancel(!status);
                }}
              >
                Salvar assim!
              </button>
              <button
                className="btn bg-secondary"
                type="button"
                onClick={() => {
                  onClickPreenchiConfirm();
                  onClickCancel(!status);
                }}
              >
                Preencher e salvar!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
